<!-- 组织信息 -->
<!-- 参数 params id   query lang -->
<!-- ex: organization/676d0acac423446de03a84c3?lang=en-->
<!-- ex: organization/676d0acac423446de03a84c3?lang=ch-->
<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getBusinessInfoDetail, database_template_name_v3, company_type_list, getFileUrl } from "@/service/index"
import { getLangValue, getLangValueByKey, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
import i18n from "@/i18n"
import PreviewImg from "@/components/common/PreviewImg";
import countryListData from '@/utils/country.js';
const route = useRoute();
// const firstIcon = require('@/assets/images/home/dc-logo-1.png')
const logo = ref({}); // logo 
const company_qualification = ref({}); // 企业资质
const showPreviewImg = ref(false) // 图片预览
// 获取组织信息
const companyInfo = ref({}); // 组织信息
const main_business_areas_list = ref([]); // 主要经营范围
const companyTypeList = ref([]); // 企业类型
const getCompanyInfo = async () => {
    // 获取组织信息
    const resp = await getBusinessInfoDetail(route.params.id);
    if (resp.code == 0) {
        companyInfo.value = resp.payload
        // logo
        let company_logo = resp.payload.company_logo
        //资质文件
        let company_qualification_id = resp.payload.company_qualification.length ? resp.payload.company_qualification[0] : ''
        // 拼接
        let pic_str_list = []
        if (company_logo) {
            pic_str_list.push(company_logo)
        }
        if (company_qualification_id) {
            pic_str_list.push(company_qualification_id)
        }
        // 获取文件url
        if (pic_str_list.length) {
            getFileUrl({ attachments: pic_str_list.join(',') }).then(resp => {
                if (resp) {
                    // logo
                    if (company_logo) {
                        let logoObj = resp.payload.find(item => item.id == company_logo)
                        if (logoObj) {
                            logo.value = logoObj
                        }
                    }
                    // 资质文件
                    if (company_qualification_id) {
                        let company_qualificationObj = resp.payload.find(item => item.id == company_qualification_id)
                        if (company_qualificationObj) {
                            company_qualification.value = company_qualificationObj
                        }
                    }
                }
            })
        }
    }
}

const getTemplateList = async () => {
    // 获取所有模板信息  显示经营范围
    const reps = await database_template_name_v3({ status: 1 })
    if (reps) {
        if (reps.payload.length == 0) {
            main_business_areas_list.value = [{ name: getLangValueByKey('base.none'), name_en: getLangValueByKey('base.none', 'en'), role_key: '无', }]
        } else {
            main_business_areas_list.value = reps.payload;
        }
    }
}

const getCompany_type_list = async () => {
    // 获取企业类型list
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
    }
}

const getCompanyTypeName = (str) => {
    // 根据企业类型id获取名字
    let arr = str ? str.split(',') : []
    let name = []
    for (const item in arr) {
        let arr1 = companyTypeList.value.filter(item1 => item1.id == arr[item])
        if (arr1.length) {
            name.push(arr1[0].name)
        }
    }
    return name.join(',')
}

const get_business_scope = (business_scope_list) => {
    // 获取主要经营领域信息
    let str = [];
    for (const item in business_scope_list) {
        const role_key = business_scope_list[item]
        let obj = main_business_areas_list.value.find(item => item.role_key === role_key)
        if (obj) {
            str.push(i18n.global.locale == 'en' ? obj.name_en : obj.name);
        }
    }
    return str.join('/');
}

const setLang = () => {
    // 设置语言
    const language = route.query.lang || 'en'
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}

const getCountryBykey = (countryKey) => {
    // 获取国家名称  中英文
    if (countryKey) {
        let arr = countryListData.filter(item => item.key === countryKey)
        if (arr.length > 0) {
            return i18n.global.locale == 'en' ? arr[0].en : arr[0].zh
        }
    }
    return ''
}
const formatterUrl = (url) => {
    // 公司链接格式化
    // 如果包含了http || https 则认为是完整链接 否则加上http
    if (!/^(?:https?|http):\/\//i.test(url)) {
        url = 'http://' + url;
    }
    return url;
}

const handleDownload = (data, name) => {
    // 文件下载
    let url = data
    const x = new window.XMLHttpRequest();
    x.open('GET', url, true);
    x.responseType = 'blob';
    x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
    };
    x.send();
}

const viewFile = () => {
    // 查看文件
    // 如果是图片才展示
    // 其他文件直接下载
    // 获取文件名（不带参数）
    const filename = company_qualification.value.name.split('/').pop().split('?')[0];

    // 获取文件类型（扩展名）
    const ext = filename.split('.').pop().toLowerCase();
    console.log(ext);
    if (ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'gif') {
        // 图片预览
        showPreviewImg.value = true
    } else {
        handleDownload(company_qualification.value.url, filename)
    }
}

const setToken = async () => {
    // 路由获取的token存到缓存里面
    let data = {
        token: route.query.token,
        timestamp:route.query.timestamp,
    }
    sessionStorage.setItem("set_menu_list", JSON.stringify(data));
}


onMounted(async () => {
    await setToken();
    setLang();
    await getTemplateList();
    await getCompany_type_list();
    getCompanyInfo() // 获取组织信息
})

</script>
<template>
    <div class="org d-flex flex-column bg-white">
        <div class="title my-3" style="max-height: 24px;">{{ getLangValue('my.account', 'organizational_details') }}
        </div>
        <div class="overflow-auto" style="flex:1">
            <div class="org-info mx-2 ">
                <div class="title-1 my-3 p-3">{{ getLangValue('my.account', 'organizational_information') }}</div>
                <div class="p-2">
                    <div class="d-flex align-items-center">
                        <div>
                            <img :src="logo?.url" style="width: 117px; height: 128px;">
                        </div>
                        <div class=" ms-2 flex-1 d-flex flex-column justify-content-between"
                            style="max-width: calc(100% - 117px);">
                            <div class="my-1 info">
                                <span class="me-2 color1">{{ getLangValue('my.account', 'form_companyName') }}</span> {{
                                    companyInfo.company_name
                                }}
                            </div>
                            <div class="my-1 info"><span class="me-2 color1">{{ getLangValue('my.account',
                                'form_contacts') }}</span>{{
                                        companyInfo.contact_name
                                    }}
                            </div>
                            <div class="my-1 info"><span class="me-2 color1">{{ getLangValue('my.account', 'form_email')
                                    }}</span>{{
                                        companyInfo.contact_email }}
                            </div>
                            <div class="my-1 info"><span class="me-2 color1">{{ getLangValue('my.account', 'form_phone')
                                    }}</span>{{
                                        companyInfo.landline_number
                                    }}
                            </div>
                            <div class="my-1 info"><span class="me-2 color1">{{ getLangValue('my.account',
                                'form_phone_number') }}</span>
                                {{ companyInfo.mobile_phone_number_area == '中国' || companyInfo.mobile_phone_number_area
                                    ==
                                    'China'
                                    ? '86' : '' }} {{ companyInfo.mobile_phone_number }}</div>
                        </div>
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{getLangValue('product-management', "code_oid")}}</span>{{ companyInfo.place_of_incorporation +
                            companyInfo.certificate_number }}
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{ getLangValue('my.account', 'form_Enterprisetype') }}</span>{{
                            getCompanyTypeName(companyInfo.company_type)
                        }}
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{ getLangValue('my.account', 'form_Enterprise_registered_address')
                            }}</span>{{
                                `${getCountryBykey(companyInfo.place_of_incorporation)}(${companyInfo.place_of_incorporation})`
                            }}
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{ getLangValue('my.account', 'form_qualification_documents')
                            }}</span><a @click="viewFile">{{ getLangValue('business-user',
                                'viewfile') }}</a>
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{ getLangValue('my.account', 'form_company_link') }}</span><a
                            :href="formatterUrl(companyInfo.company_website)" target="_blank">{{
                                companyInfo.company_website }}</a>
                    </div>
                    <div class="my-2 info">
                        <span class="me-2 color1">{{ getLangValue('my.account', 'form_main_business_areas') }}</span>{{
                            get_business_scope(companyInfo.business_scope) }}
                    </div>
                </div>
            </div>
            <!-- 生产地址 -->
            <div class="production-info  mx-2" v-if="companyInfo.company_address?.length">
                <div class="title-1 my-3 p-3">{{ getLangValue('my.account', 'enterprise_production_address') }}</div>
                <div class="p-2">
                    <!-- 生产地址 -->
                    <template v-if="companyInfo.company_address?.length">
                        <div class="my-2 info" v-for="(item, key) in companyInfo.company_address" :key="key">
                            <div class="my-2 color1">{{ getLangValue('product-template', 'origin') }}{{ key + 1 }}</div>
                            <div class="d-flex align-items-center my-2">
                                <span class="me-2 color1 " style="flex: 1;">
                                    {{ getLangValue('my.account',
                                        'enterprise_production_address') }}{{ key + 1 }}</span>
                                <span style="flex: 2;">
                                    {{ item.name + item.province + item.city + item.address1 }}
                                </span>

                            </div>
                            <div class="my-2 d-flex align-items-center">
                                <span class="me-2 color1" style="flex: 1;">{{getLangValue('product-management', "fid")}}</span>
                                <span style="flex: 2;">
                                    FBD-{{ companyInfo.certificate_number }}-{{
                                        (item.name + item.province + item.city +
                                            item.address1).replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')
                                    }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!-- 企业通讯地址 -->
            <div class="production-info  mx-2" v-if="companyInfo.contact_address?.length">
                <div class="title-1 my-3 p-3">{{ getLangValue('my.account', 'contact_address') }}</div>
                <div class="p-2">
                    <template v-if="companyInfo.contact_address?.length">
                        <div class="my-2 info" v-for="(item, key) in companyInfo.contact_address" :key="key">
                            <!-- <div class="my-2 color1">{{ getLangValue('product-template', 'origin') }}{{ key + 1 }}</div> -->
                            <div class="d-flex align-items-center my-2">
                                <span class="me-2 color1 " style="flex: 1;">
                                    {{ getLangValue('my.account',
                                        'contact_address') }}</span>
                                <span style="flex: 2;">
                                    {{ item.name + item.province + item.city + item.address1 }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="company_qualification?.url" :myWidth="200"
        v-if="showPreviewImg">
    </PreviewImg>
</template>
<style lang="scss" scoped>
.org {
    height: 100Vh;
    overflow-y: auto;

    .title {
        color: #003A8C;
        font-size: 1rem;
        text-align: center;
        font-weight: bold;
    }

    .org-info,
    .production-info {
        // border-top: 1px solid #0000001A;
        box-shadow: 0px 4px 15px 2px rgba(0, 0, 0, 0.1);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .title-1 {
            color: rgba(255, 255, 255, 1);
            font-size: 0.9rem;
            text-align: left;
            font-weight: bold;
            background-color: rgba(10, 179, 156, 1);
            height: 48px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }

        .color1 {
            color: rgba(10, 179, 156, 1);
        }

        a {
            color: #2D84DA;
            text-decoration: underline !important;
        }

        .info {
            word-break: break-all;
        }
    }
}
</style>